import {boundaryListActionType } from "./actionTypes";

export const boundaryListAction = (boundaries) => ({
    type: boundaryListActionType,
    payload:boundaries
})
